export const APP_DATA_STORAGE_KEY = "haebolcae.app-data.v1";
export const RECOVERY_KEY_PREFIX = `${APP_DATA_STORAGE_KEY}:recovery:`;
export const TOSS_RECOVERY_INDEX_KEY = `${APP_DATA_STORAGE_KEY}:recovery-index`;
